import type { CSSObject } from "@emotion/react";

type GlassBorderOptions = {
  borderRadius?: number | string;
  borderWidth?: number | string;
  gradientFrom: string;
  gradientTo: string;
  gradientMid?: string;
  gradientAngle?: number;
  opacity?: number;
  inset?: number | string;
};

const toPx = (value: number | string): string =>
  typeof value === "number" ? `${value}px` : value;

export const createGlassBorderStyles = ({
  borderRadius = 12,
  borderWidth = 1,
  gradientAngle = 145,
  gradientFrom,
  gradientMid,
  gradientTo,
  inset = 0,
  opacity = 1
}: GlassBorderOptions): CSSObject => ({
  "&::before": {
    background: gradientMid
      ? `linear-gradient(${gradientAngle}deg, ${gradientFrom} 8%, ${gradientMid} 42%, ${gradientTo} 82%)`
      : `linear-gradient(${gradientAngle}deg, ${gradientFrom} 10%, ${gradientTo} 82%)`,
    borderRadius: toPx(borderRadius),
    content: '""',
    inset: toPx(inset),
    maskComposite: "exclude",
    opacity,
    padding: toPx(borderWidth),
    pointerEvents: "none",
    position: "absolute",
    WebkitMask:
      "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
    WebkitMaskComposite: "xor",
    zIndex: 0
  }
});
